import React, { useEffect, useState } from "react";
import { usePackages } from "../../../../../hooks/usePackages";
import {
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
  LabelList,
  CartesianGrid,
  LineChart,
  Line,
} from "recharts";
import { handleMonth, translate } from "../../../../../utils/Common";
import Spinner from "../../../../../components/Spinner";
import { LuBox } from "react-icons/lu";
import PlatformSearchList from "../../../../../components/PlatformSearchList";
import { useForm } from "react-hook-form/dist/index.ie11";
import Select from "../../../../../components/common/Select";
import styles from "./Charts.module.css";

const PackagesPickupMonthByLocker = (props) => {
  const { yearSelect, canReadFilters = true } = props;
  const { getPickupMonthByLocker } = usePackages();
  const { register, errors, setValue } = useForm();
  const [platformSelect, setPlatformSelect] = useState(null);
  const [typePackage, setTypePackage] = useState(2);
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState(null);

  const getData = async () => {
    setIsLoading(true);
    const signal = new AbortController().signal;
    const result = await getPickupMonthByLocker(signal, {
      year: Number(yearSelect),
      lockerId: platformSelect?.boxitLocationId ? Number(platformSelect?.boxitLocationId) : null,
      typePackage: Number(typePackage),
    });
    setIsLoading(false);

    if (result.length > 0) {
      const formattedData = result.map((item) => ({
        month: handleMonth(item?.monthCurrent),
        total: item?.result,
        lockerName: item?.nameClient,
      }));
      setData(formattedData);
    } else {
      setData([]);
    }
  };

  useEffect(() => {
    if (canReadFilters && platformSelect === null) return;
    getData();
  }, [yearSelect, platformSelect, typePackage, canReadFilters]);

  const typePackageOptions = [
    { value: "2", label: translate("global.status.typePackage.regular") },
    { value: "3", label: translate("global.status.typePackage.returned") },
  ];

  return (
    <div className={styles.chartSection}>
      <div className={styles.chartHeaderRow}>
        <h6 className={styles.chartTitle}>
          {isLoading ? <span><Spinner type={1} /></span> : <LuBox size={20} aria-hidden />}{" "}
          {translate("global.packagesPickupLockerXMonth")} -{" "}
          <span className={styles.chartTitleAccent}>{yearSelect}</span>
        </h6>
        {canReadFilters && (
          <div className={styles.filterGroup}>
            <label htmlFor="inputTypePackage" className={styles.filterLabel}>
              <LuBox size={12} /> {translate("global.typeOfPackage")}
            </label>
            <Select
              id="inputTypePackage"
              value={String(typePackage)}
              onChange={(e) => setTypePackage(Number(e.target.value))}
              options={typePackageOptions}
              size="sm"
            />
          </div>
        )}
      </div>

      <hr className={styles.chartDivider} />

      {canReadFilters && (
        <div className={styles.chartFilters}>
          <div className={styles.selectWrapper} style={{ width: "200px" }}>
            <PlatformSearchList
              register={register}
              errors={errors}
              setPlatformSelect={setPlatformSelect}
              platfSelect={platformSelect}
              valueId={"plataforma"}
              readOnly={false}
              setValue={setValue}
              isClearable
            />
          </div>
        </div>
      )}

      {!canReadFilters || platformSelect !== null ? (
        data === null ? null : data.length === 0 ? (
          <div className={styles.noDataCard}>{translate("global.noDataToView")}</div>
        ) : (
          <div className={styles.chartContainer} style={{ height: 350 }}>
            <ResponsiveContainer width="100%" height="100%">
              <LineChart data={data} margin={{ top: 30, right: 50, left: 50, bottom: 20 }}>
                <CartesianGrid strokeDasharray="3 3" stroke="var(--border-light)" />
                <XAxis dataKey="month" stroke="var(--text-secondary)" interval={0} />
                <YAxis stroke="var(--text-secondary)" />
                <Tooltip labelFormatter={(label) => `${label} ${yearSelect}`} />
                <Legend />
                <Line
                  type="monotone"
                  dataKey="total"
                  name={translate("global.packages")}
                  stroke="var(--color-primary)"
                  strokeWidth={3}
                  dot={{ fill: "var(--color-primary)", r: 5 }}
                  activeDot={{ r: 8 }}
                  strokeLinejoin="round"
                  strokeLinecap="round"
                >
                  <LabelList
                    dataKey="total"
                    position="top"
                    fill="var(--text-primary)"
                    fontSize={12}
                  />
                </Line>
              </LineChart>
            </ResponsiveContainer>
          </div>
        )
      ) : null}
    </div>
  );
};

export default PackagesPickupMonthByLocker;
